import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { ContextMenuOption } from 'projects/shared/src/lib/models/context-menu-option';
import {
  AbsenceFormComponent,
  InspectionFormComponent,
  MachineFormComponent,
  RouterService,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';

@Component({
  selector: 'app-machinery-overview',
  templateUrl: './machinery-overview.component.html',
  styleUrls: ['./machinery-overview.component.scss'],
  standalone: false,
})
export class MachineryOverviewComponent implements OnInit {
  constructor(
    public routerService: RouterService,
    public state: StateService,
    public modalController: ModalController,
    public toolService: ToolService,
    private platform: Platform
  ) {}

  ngOnInit() {}

  handleRefresh(event: any) {
    this.state.loadAbsenceEntries().subscribe((x) => {
      event.target.complete();
    });
  }

  async documentButtonClicked(type: string) {
    if (type == 'machine') {
      const modal = await this.modalController.create({
        component: MachineFormComponent,
        componentProps: {},
        cssClass: this.state.isBigScreen ? 'height-desktop-modal' : '',
      });
      modal.present();
      const { data, role } = await modal.onWillDismiss();
    } else if (type == 'inspection') {
      const modal = await this.modalController.create({
        component: InspectionFormComponent,
        cssClass: this.state.isBigScreen ? 'height-desktop-modal' : '',
        componentProps: {},
      });
      modal.present();
      const { data, role } = await modal.onWillDismiss();
    }
  }

  async openContextMenu(event: MouseEvent) {
    let additionalOptions: ContextMenuOption[] = [
      {
        icon: 'boat-outline',
        label: 'Neue Maschine',
        value: 'machine',
      },
      {
        icon: 'document-text-outline',
        label: 'Neue Prüfung',
        value: 'inspection',
      },
    ];
    const { data, role } = await this.state.openPopover(
      event,
      false,
      additionalOptions
    );
    if (data) this.documentButtonClicked(data);
  }
}
